import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

/**
 * Add buttons in the cart drawer's "Complete the look" row (snippets/cart-cross-sell.liquid).
 * Listens on the document because the drawer contents are morphed on every cart change.
 */
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-cross-sell-add]') : null;
  if (!(button instanceof HTMLButtonElement) || button.getAttribute('aria-busy') === 'true') return;

  const card = button.closest('.cart-cross-sell__card');
  const select = card?.querySelector('[data-cross-sell-variant]');
  const variantId = select instanceof HTMLSelectElement ? select.value : button.dataset.variantId;
  if (!variantId) return;

  const sectionIds = new Set();
  if (button.dataset.sectionId) sectionIds.add(button.dataset.sectionId);
  document.querySelectorAll('cart-items-component').forEach((component) => {
    if (component instanceof HTMLElement && component.dataset.sectionId) sectionIds.add(component.dataset.sectionId);
  });

  button.setAttribute('aria-busy', 'true');

  try {
    const body = JSON.stringify({
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: Array.from(sectionIds).join(','),
      sections_url: window.location.pathname,
    });
    const response = await fetch(Theme.routes.cart_add_url, fetchConfig('json', { body }));
    const data = await response.json();

    if (!response.ok || data.status) {
      const status = button.closest('.cart-cross-sell')?.querySelector('[data-cross-sell-status]');
      if (status) {
        status.textContent = data.description || data.message || 'Could not add this item.';
        status.classList.remove('visually-hidden');
      }
      button.removeAttribute('aria-busy');
      return;
    }

    const cart = await (await fetch(`${Theme.routes.cart_url}.js`)).json();

    button.dispatchEvent(
      new CartAddEvent(cart, 'cart-cross-sell', {
        source: 'cart-cross-sell',
        itemCount: cart.item_count,
        variantId,
        sections: data.sections,
      })
    );
  } catch (error) {
    console.error(error);
    button.removeAttribute('aria-busy');
  }
});
